import { Component, OnInit, inject, ChangeDetectionStrategy, signal, input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {EntityKey} from '../entity/entity';
import {PersonLogin} from '../person/person-login';
import {SelectionItem} from '../selections/selection-item';
import {IecTaskService} from '../services/iec-task-service';
import {OrderService} from '../services/order-service';
import {PersonLoginService} from '../services/person-login-service';
import {SelectionService} from '../services/selection-service';
import {TaskResponseService} from '../services/task-response-service';
import {StringUtils} from '../utils/string-utils';
import {IecTask} from './iec-task';
import {OrderCancelTaskResponse} from './order-cancel-task-response';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';



@Component({
    selector: 'cancellation-request-task',
    templateUrl: './cancellation-request-task.component.html',
    styleUrls: ['./cancellation-request-task.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatButton, MatIcon, MatProgressSpinner]
})
export class CancellationRequestTaskComponent implements OnChanges, OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly taskResponseService = inject(TaskResponseService);
  private readonly iecTaskService = inject(IecTaskService);
  private readonly selectionService = inject(SelectionService);
  private readonly orderService = inject(OrderService);
  private readonly router = inject(Router);
  readonly taskId = input.required<string>({ alias: 'task-id' });


  private personLogin!: PersonLogin;
  readonly cancelReasons = signal<SelectionItem[]>(undefined!);
  readonly task = signal<IecTask>(undefined!);
  response!: OrderCancelTaskResponse;
  readonly isBusy = signal<boolean>(false);
  readonly errorMessage = signal<string>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.response = new OrderCancelTaskResponse();
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.selectionService.getCancelReasons("CONTRACT").subscribe(response => {
        this.cancelReasons.set(response);
      }, error => this.handleError(error));
      this.initialize();
    }
  }

  saveResponse(): void {
    this.isBusy.set(true);
    this.taskResponseService.orderCancel(this.task().id, this.response).subscribe(() => this.router.navigate(['main']), error => this.handleError(error));
  }

  revertCancelRequest(): void {
    this.isBusy.set(true);
    const key: EntityKey = new EntityKey();
    key.entityName = 'CONTRACT';
    key.entityId = this.task().entityId;
    key.entityRevision = this.task().entityRevision;
    this.orderService.revertCancel(key).subscribe({
      next: () => this.router.navigate(['orders', this.task().entityId, this.task().entityRevision]),
      error: (error) => this.handleError(error),
    });
  }

  private handleError(error: any) {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }


  private initialize(): void {
    let taskIdString: string = this.taskId();
    if (taskIdString && !isNaN(+taskIdString) && +taskIdString > 0) {
      this.iecTaskService.getTask(+taskIdString).subscribe(result => this.task.set(result), error => this.handleError(error));
    } else {
      this.router.navigate(['main']);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['taskId'].firstChange) {
      this.initialize();
    }
  }
}
